import axios from 'axios'
import qs from 'qs'

const api = axios.create({
  baseURL: '/employee/',
})
api.interceptors.response.use(
  r => r,
  error => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/login'
    }
    return Promise.reject(error)
  },
)

// add support for nested query params, e.g. filter[id]=1 instead of filter={id: 1}
api.interceptors.request.use(config => {
  config.paramsSerializer = params => {
    return qs.stringify(params, {
      arrayFormat: 'brackets',
      encode: false,
    })
  }
  return config
})
export { api }

export const getStudyPlanSubscribableGroupings = (studentId, queryParams) => api.get(`students/${studentId}/study-plan/api/subscribable-groupings`, { params: queryParams })
export const getStudyPlanStudentCharacteristics = (studentId, queryParams) => api.get(`students/${studentId}/study-plan/api/student-characteristics`, { params: queryParams })
export const postStudyPlanApproved = (studentId, data) => api.post(`students/${studentId}/study-plan/api/approved`, data)
export const postStudyPlanUnApproved = (studentId, data) => api.post(`students/${studentId}/study-plan/api/unapproved`, data)
export const postUnsubscriptionCourse = (studentId, data) => api.post(`students/${studentId}/study-plan/api/unsubscription-course`, data)

export const getAdvises = (studentId, queryParams) => api.get(`api/students/${studentId}/advises`, { params: queryParams })
export const addReaction = (adviseId, data) => api.post(`api/advises/${adviseId}/messages`, data)
export const completeAdvise = (adviseId) => api.post(`api/advises/${adviseId}/complete`)

export const getQuestionTemplates = (queryParams) => api.get('/api/question-templates', { params: queryParams })
export const getQuestionTemplateAnwsers = (queryParams) => api.get('/api/question-template-answers', { params: queryParams })

export const getLabels = (queryParams) => api.get('/api/labels', { params: queryParams })
export const getStudentCharacteristics = (queryParams) => api.get('/api/student-characteristics', { params: queryParams })
export const getGroups = (queryParams) => api.get('/api/groups', { params: queryParams })
export const getEmployees = (queryParams) => api.get('/api/employees', { params: queryParams })
export const getTerms = (queryParams) => api.get('/api/terms', { params: queryParams })

export const getEvent = (eventId, queryParams) => api.get(`/api/events/${eventId}`, { params: queryParams })
export const updateEvent = (eventId, data) => api.put(`api/events/${eventId}`, data)
export const deleteEvent = (eventId) => api.delete(`api/events/${eventId}`)
export const moveStudentToEvent = (data) => api.post(`api/student-event-connections/move`, data)
export const createAssessmentConfig = (eventId, data) => api.post(`api/events/${eventId}/assessment-configs`, data)
export const updateAssessmentConfig = (assessmentConfigId, data) => api.put(`api/assessment-configs/${assessmentConfigId}`, data)
export const generateAssessmentConfigEvents = (assessmentConfigId, data) => api.post(`api/assessment-configs/${assessmentConfigId}/generate`, data)
export const addAssessmentConfigEvent = (assessmentConfigId, data) => api.post(`api/assessment-configs/${assessmentConfigId}/add-event`, data)
export const finalizeEventAssessmentConfig = (assessmentConfigId, data) => api.post(`api/assessment-configs/${assessmentConfigId}/finalize`, data)
